import {
    SET_PRIMARY_SIDEBAR_DATA,
    TOGGLE_KEEP_SIDEBAR_OPENED,
    TOGGLE_PRIMARY_SIDEBAR,
    TOGGLE_SOLUTION_USERS,
    TOGGLE_USER_SETTINGS,
} from "app/action_types/primary_sidebar3_action_type";
import { EPrimarySideBar3IdType, EPrimarySideBar3StateType } from "app/reducers/_reducers/PrimarySidebar3Reducer";

export const togglePrimarySidebar = (isOpened: boolean) => {
    return {
        type: TOGGLE_PRIMARY_SIDEBAR,
        isPrimarySidebarOpened: isOpened,
    };
};
export const toggleUserSettings = (isOpened: boolean) => {
    return {
        type: TOGGLE_USER_SETTINGS,
        isUserSettingsOpened: isOpened,
    };
};
export const toggleKeepSidebarOpened = (isOpened: boolean) => {
    return {
        type: TOGGLE_KEEP_SIDEBAR_OPENED,
        isKeepSidebarOpened: isOpened,
    };
};
export const toggleSolutionUsers = (isOpened: boolean) => {
    return {
        type: TOGGLE_SOLUTION_USERS,
        isSolutionUsersOpened: isOpened,
    };
};

export const setPrimarySidebarType = (state: EPrimarySideBar3StateType, id: EPrimarySideBar3IdType) => {
    const primaryBarData = { state, id };
    return {
        type: SET_PRIMARY_SIDEBAR_DATA,
        primaryBarData,
    };
};
